import { render, staticRenderFns } from "./CsatAnswer.vue?vue&type=template&id=3320f902&scoped=true"
import script from "./CsatAnswer.vue?vue&type=script&lang=js"
export * from "./CsatAnswer.vue?vue&type=script&lang=js"
import style0 from "./CsatAnswer.vue?vue&type=style&index=0&id=3320f902&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3320f902",
  null
  
)

export default component.exports